import React from 'react';
import { View, SafeAreaView, Image, StyleSheet, ImageBackground } from 'react-native';

import { useDispatch } from 'react-redux';

import { CommonStyles, CommonProperties, Color, FontSize } from '../../styles';
import { useNavigation } from '@react-navigation/native';
import { scale } from '../../utils/scale.utils';
import RowView from '../RowView';
import BaseText from '../BaseText';
import Icon from '../Icon';
import Images from '../../constants/Images';

const IndustryAlert = ({ trip, type }) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  return (
    <View style={[styles.container, CommonStyles.boxShadow]}>
      <RowView style={styles.topHeading}>
        <Image source={{ uri: 'https://picsum.photos/80' }} style={styles.smallImage} />
        <View style={styles.cardHeading}>
          <BaseText style={styles.mediumText}>TripEasy</BaseText>
          <BaseText style={CommonStyles.h4}>{type} Message</BaseText>
        </View>
        <BaseText style={styles.mediumText}>1h</BaseText>
      </RowView>
      <View style={styles.cardContainer}>
        <BaseText style={styles.cardContent}>
          American Airlines has reached a new deal for air travel to China from United States of
          America. Please be Aware these routes will not take effect until January 2021. Find out
          more by
          <BaseText style={styles.linkText}> Clicking here</BaseText>
        </BaseText>
        {type == 'Industry' && (
          <Image style={styles.companyImage} source={Images.air['74x74'].AA} />
        )}
        {type == 'Company' && (
          <>
            <Image style={styles.companyImage} source={{ uri: 'https://picsum.photos/80' }} />
            <View style={styles.bottomSection}>
              <BaseText>General Manager</BaseText>
              <BaseText>Adam Andy</BaseText>
            </View>
          </>
        )}
        {type == 'Advisory' && (
          <BaseText style={[styles.bottomSection, styles.linkText]}>
            Click here to Read More
          </BaseText>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    ...CommonProperties.mx5,
    ...CommonProperties.mt3,
    borderTopLeftRadius: scale(6),
    borderTopRightRadius: scale(6),
  },
  topHeading: {
    ...CommonProperties.p3,
  },
  smallImage: {
    height: 44,
    width: 44,
    borderRadius: 22,
  },
  mediumText: {
    color: Color.text.medium,
  },
  cardHeading: {
    flex: 1,
    ...CommonProperties.pl3,
  },
  cardContainer: {
    flex: 1,
    backgroundColor: '#F6F6F6',
    ...CommonProperties.py5,
  },
  cardContent: {
    ...CommonProperties.mx2,
    ...CommonProperties.px3,
    ...CommonProperties.mt3,
  },
  companyImage: {
    height: 44,
    width: 44,
    borderRadius: 22,
    ...CommonProperties.m4,
  },
  linkText: {
    color: Color.primary,
  },
  bottomSection: {
    ...CommonProperties.mx4,
  },
});

export default IndustryAlert;
